// AD-2764 (Maria, 23 October 2026): the name is changed in place beside the tabs. A name left empty, or only spaces,
// puts the name from before back, as a form must have a name. Names are cut at 128 characters, as before.
export const FORM_NAME_MAX_LENGTH = 128;

export const typedFormName = (value) => (value ?? '').slice(0, FORM_NAME_MAX_LENGTH);

export const nameAfterEditing = (edited, before) => (edited?.trim() ? edited : before);
